module.exports = __webpack_public_path__ + "img/icon_map_11_on_101.d8a277df.png";